module.exports = __webpack_public_path__ + "static/img/clothing_07.c72757f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_07.png
// module id = fmEn
// module chunks = 0